export default __webpack_public_path__ + "static/media/flag_on.9370399a.svg";